/** @format */

import { Input } from "antd";
import React, { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import { SearchOutlined } from "@ant-design/icons";

import pdf from "../../../icons/pdf.png";
import print from "../../../icons/print.png";
import excel from "../../../icons/excel.png";
import { ExcelPrint, Pdf } from "../../../components/functions/Print";

const tableData = [
  ["Qoraqalpog‘iston Respublikasi"],
  ["Suv xo‘jaligi vazirligi"],
  ["Amudaryodan-jami"],
  ["sh.j. O‘ng qirg‘oq kanali"],
  ["Upradik tizimidan"],
  ["sh.j. Gurlan shoxobchasi"],
  ["Qipchoq Bozsu shoxobchasi"],
  ["Qlichboy shoxobchasi"],
  ["Daryodan nasos orqali Qipchoqqacha"],
  ["Suenli"],
  ["Parallelniy"],
  ["GRES kanali"],
  ["Qizketgan"],
  ["Risoviy"],
  ["Daryodan nasos orqali Qipchoqdan keyin"],
  ["Chapqirg‘oq Amudaryo ITHB"],
].map((item, idx) => ({
  no: idx + 1,
  name: item[0],
  data: [
    400, 2.9, 2.9, 2.9, 2.9, 1296, 1296, 1296, 1296, 2.9, 2.9, 2.9, 1296, 53,
  ],
}));

const Table24 = () => {
  const componentPDF = useRef();
  const generatePDF = useReactToPrint({
    content: () => componentPDF.current,
    documentTitle: "Statistik hisobotlar",
  });

  return (
    <>
      <div className='table-content-top'>
        <div className='table-top-left'>
          <Input
            prefix={<SearchOutlined className='site-form-item-icon' />}
            placeholder='Search'
          />
        </div>

        <ul className='table-top-right'>
          <li>
            <button className='btn p-0' onClick={generatePDF}>
              <img src={print} alt='print' />
            </button>
          </li>

          <li>
            <button onClick={() => Pdf("tblData")} className='btn p-0'>
              <img src={pdf} alt='pdf' />
            </button>
          </li>

          <li>
            <button
              className='btn p-0'
              onClick={() =>
                ExcelPrint("Statistik hisobotlar", "sheet 1", "tblData")
              }>
              <img src={excel} alt='excel' />
            </button>
          </li>
        </ul>
      </div>

      <div className='table-responsive tableFixHead'>
        <div ref={componentPDF} style={{ width: "100%" }}>
          <table id='tblData' className='table table-bordered table-style'>
            <thead>
              <tr>
                <th rowSpan={3}>№</th>
                <th colSpan={15}>
                  6 bo‘lim. Tabiiy suv manbalaridan olingan, boshqa korxona
                  (tashkilot) lardan qabul qilib olingan, foydalanilgan va
                  berilgan suvi
                </th>
              </tr>

              <tr>
                <th rowSpan={2}>
                  Suv manbalari (daryo, soy, kanal, suv omborlari, kollektor,
                  quduq va boshqalar)
                </th>

                <th rowSpan={2}>Satr raqami</th>
                <th rowSpan={2}>Yil davomida olingani, mln.m3</th>
                <th colSpan={12}>Shu jumladan</th>
              </tr>

              <tr>
                <th>Yanvar</th>
                <th>Fevral</th>
                <th>Mart</th>
                <th>Aprel</th>
                <th>May</th>
                <th>Iyun</th>
                <th>Iyul</th>
                <th>Avgust</th>
                <th>Sentabr</th>
                <th>Oktabr</th>
                <th>Noyabr</th>
                <th>Dekabr</th>
              </tr>
            </thead>

            <tbody>
              {tableData.map((row, idx) => (
                <tr key={idx}>
                  <th>{row.no}</th>
                  <th>{row.name}</th>
                  {row.data.map((cell, i) => (
                    <td key={i}>{cell}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default Table24;
